import { configureStore } from "@reduxjs/toolkit";

// auth
import auth from "../features/auth/Slice";

//common
import common from "../features/common/Slice";

//user
import user from "../features/user/Slice";

export const store = configureStore({
  reducer: {
    //auth
    auth: auth,
     //common
    common: common,
     //user
    user: user,
  },
});
